// Thin wrappers around /api/fleet — the model-routing registry and the heavy
// lane's live swarm (backend/modules/fleet). Any authenticated user server-
// side; the PAGE is mindshine-staff-gated (see utils/staff.js).
import { fetchData } from '../fetchapi/fetchapi';

export async function getFleetModels() {
  return fetchData('fleet/models');
}

// Heavy-lane swarm: running / queued / waiting app requests with the parsed
// worker tick, pod liveness, typical durations and recent results.
export async function getFleetHeavy() {
  return fetchData('fleet/heavy');
}

// `change` is a model id (repoint the route) or an object { model_id }.
export async function setModelRoute(consumer, change) {
  const body = typeof change === 'string' ? { model_id: change } : (change || {});
  return fetchData(`fleet/routes/${encodeURIComponent(consumer)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

// One CELL of the Models & vendors matrix: the model `consumer` runs whenever
// it runs on `vendor` (natively or on relay); null = "not on this vendor".
// Answers { route, routes } — every row the change touched (the subagent row
// follows the orchestrator's vendors).
export async function setModelRouteCell(consumer, vendor, model_id) {
  return fetchData(`fleet/routes/${encodeURIComponent(consumer)}/models/${encodeURIComponent(vendor)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ model_id: model_id || null }),
  });
}

// Fleet sessions — every worker session the fleet ran: what it was about, the
// cards it worked, the model, how it ended, and its transcripts stored on S3.
export async function getFleetSessions(params = {}) {
  const q = new URLSearchParams(Object.entries(params).filter(([, v]) => v != null && v !== "")).toString();
  return fetchData(`fleet/sessions${q ? `?${q}` : ""}`);
}
export async function getTranscriptUrl(tid) {
  return fetchData(`app_requests/transcripts/${tid}/url`, { method: "POST" });
}

// Subscription-key REGISTRY (key pool phase 3): the keys the fleet may run on,
// managed from the page. Staff only server-side (email domain). Secrets go up
// once (add / rotate) and never come back — the list carries fingerprints.
export async function getFleetKeys() {
  return fetchData('fleet/keys');
}
export async function addFleetKey({ label, vendor, secret, note }) {
  return fetchData('fleet/keys', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ label, vendor, secret, note }),
  });
}
export async function updateFleetKey(label, patch) {
  return fetchData(`fleet/keys/${encodeURIComponent(label)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(patch),
  });
}
export async function rotateFleetKey(label, secret) {
  return fetchData(`fleet/keys/${encodeURIComponent(label)}/secret`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ secret }),
  });
}
export async function removeFleetKey(label, { force = false } = {}) {
  return fetchData(`fleet/keys/${encodeURIComponent(label)}${force ? '?force=1' : ''}`, { method: 'DELETE' });
}
